import React from "react";

/**
 * Toast row. Compose a `ToastStack` for the visual stack.
 * @param {Object} props
 * @param {"info"|"success"|"warning"|"error"} [props.variant="info"]
 */
export function Toast({ variant = "info", children }) {
  const colorVar = TOKEN[variant];
  return (
    <div className="ds-toast">
      <span className="ds-toast-icon" style={{ background: `var(${colorVar})` }} />
      {children}
    </div>
  );
}

export function ToastStack({ children }) {
  return <div className="ds-toast-stack">{children}</div>;
}

const TOKEN = {
  info: "--color-status-info",
  success: "--color-status-positive",
  warning: "--color-status-warning",
  error: "--color-status-danger",
};
